export default __webpack_public_path__ + "static/media/glrc-course.laminated-doughs.08e6ac7d.png";